<div class="package-status-container">
  <!-- pending -->
  @if (
    !packagesFlowService.suspendedPackage &&
    (packagesFlowService.pendingPackage ||
      packagesFlowService.enrollingPackageButCreditEnded)
  ) {
    <div class="package-status-detail">
      <i class="fa-light fa-spinner-third fa-spin spinner"></i>
      <div class="package-status-info-title" translate>
        texts.Package_Status_Pending_Title
      </div>
    </div>

    <button
      class="action-button"
      (click)="
        retryPayment(
          packagesFlowService.pendingPackage ||
            packagesFlowService.enrollingPackageButCreditEnded
        )
      "
      translate
    >
      texts.Package_Status_Pay_Button
    </button>
  }
  <!-- suspended -->
  @if (packagesFlowService.suspendedPackage) {
    <div class="package-status-detail">
      <app-svg-icon name="danger_triangle"></app-svg-icon>
      <div>
        <div class="package-status-info-title" translate>
          {{
            packagesFlowService.suspendedPackage.paymentIntent?.status ==
            PaymentIntentStatus.success
              ? "texts.Package_Status_Suspended_By_Admin_Title"
              : "texts.Package_Status_Suspended_Not_Available_Title"
          }}
        </div>
        <p class="package-status-info-description" translate>
          {{
            packagesFlowService.suspendedPackage.paymentIntent?.status ==
            PaymentIntentStatus.success
              ? "texts.Package_Status_Suspended_By_Admin_Description"
              : "texts.Package_Status_Suspended_Not_Available_Description"
          }}
        </p>
      </div>
    </div>
    <button class="action-button" (click)="navigateToContactPage()" translate>
      texts.Contact_Us
    </button>
  }
</div>
